<template>
  <FileUploadsTable data-testid="file-uploads-table" />
</template>
<script>
import FileUploadsTable from "@/v3components/Datatables/FileUploadsTable.vue"

export default {
  name: "FileUploads",
  components: { FileUploadsTable }
}
</script>
